export default __webpack_public_path__ + "assets/venue-group.1ba3ece1.svg";